import { render, staticRenderFns } from "./Nfce.vue?vue&type=template&id=13815688&scoped=true&"
import script from "./Nfce.vue?vue&type=script&lang=js&"
export * from "./Nfce.vue?vue&type=script&lang=js&"
import style0 from "./Nfce.vue?vue&type=style&index=0&id=13815688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13815688",
  null
  
)

export default component.exports